import { Grid } from '@mui/material';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import ReactHookFormSelect from '../ReactHookForm/ReactHookFormSelect';
import { useHEMTLocations, useWorktypes } from '../../hooks';
import FormDialog from '../Dialogs/FormDialog';

const CreateCapacityDialog = ({
    showDialog,
    channelOptions,
    taskOptions,
    capacityTypeOptions,
    onSubmit,
    isLoading,
    onClose,
}) => {
    const { t } = useTranslation();
    const allLocationsFromHEMT = useHEMTLocations();

    const form = useForm({
        defaultValues: {
            location: '',
            worktype: '',
            channel: '',
            task: '',
            capacityTypes: [],
        },
    });
    const {
        watch,
        formState: { errors },
        resetField,
        control,
    } = form;
    const selectedLocation = watch('location');

    const [worktypeOptions] = useWorktypes({
        location: selectedLocation,
    });

    const handleClose = () => {
        onClose();
    };

    useEffect(() => {
        if (selectedLocation) {
            resetField('worktype');
        }
    }, [selectedLocation, resetField]);

    return (
        <FormDialog
            title={t('capacity.createTitle')}
            showDialog={showDialog}
            form={form}
            onSubmit={onSubmit}
            onClose={handleClose}
            isLoading={isLoading}
        >
            <Grid item xs={12}>
                <ReactHookFormSelect
                    name="location"
                    options={allLocationsFromHEMT}
                    mainProp="code"
                    secondProp="city"
                    label={t('field.location')}
                    control={control}
                    rules={{ required: { value: true, message: t('validation.required') } }}
                    formErrors={errors}
                ></ReactHookFormSelect>
            </Grid>
            <Grid item xs={12}>
                <ReactHookFormSelect
                    name="worktype"
                    options={worktypeOptions}
                    mainProp="worktype"
                    label={t('field.worktype')}
                    control={control}
                    rules={{ required: { value: true, message: t('validation.required') } }}
                    formErrors={errors}
                ></ReactHookFormSelect>
            </Grid>
            <Grid item xs={12}>
                <ReactHookFormSelect
                    name="channel"
                    options={channelOptions}
                    mainProp="name"
                    label={t('field.channel')}
                    control={control}
                    rules={{ required: { value: true, message: t('validation.required') } }}
                    formErrors={errors}
                ></ReactHookFormSelect>
            </Grid>
            <Grid item xs={12}>
                <ReactHookFormSelect
                    name="task"
                    options={taskOptions}
                    mainProp="name"
                    label={t('field.task')}
                    control={control}
                    rules={{ required: { value: true, message: t('validation.required') } }}
                    formErrors={errors}
                ></ReactHookFormSelect>
            </Grid>
            <Grid item xs={12}>
                <ReactHookFormSelect
                    name="capacityTypes"
                    options={capacityTypeOptions}
                    mainProp="name"
                    label={t('field.capacityTypes')}
                    control={control}
                    rules={{ required: { value: true, message: t('validation.required') } }}
                    formErrors={errors}
                    isMultiSelect={true}
                ></ReactHookFormSelect>
            </Grid>
        </FormDialog>
    );
};

export default CreateCapacityDialog;
